// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_18-7";
export var adjustableWidthBorderHeld = "_18-8";
export var arrow = "_18-3";
export var arrowButton = "_18-4";
export var headerCell = "_18-0";
export var help = "_18-2";
export var icon = "_18-1";
export var iconWrapper = "_18-6";
export var noBorder = "_18-b";
export var nonAdjustableWidthBorder = "_18-9";
export var nonAdjustableWidthBorderHeld = "_18-a";
export var textButton = "_18-5";